import { actionCreator } from '@ardoq/rxbeach';
import { ArdoqId, ComponentSurveyWithApprovalStatus } from '@ardoq/api-types';
import { EnhancedScopeData } from '@ardoq/data-model';

export const getComponentOverviewPageData = actionCreator<ArdoqId>(
  '[componentOverviewPage] GET_COMPONENT_OVERVIEW_DATA'
);

export type SetComponentOverviewDataPayload = {
  scopeData: EnhancedScopeData;
  componentId: ArdoqId;
};

export const setComponentOverviewData =
  actionCreator<SetComponentOverviewDataPayload>(
    '[componentOverviewPage] SET_COMPONENT_OVERVIEW_DATA'
  );

export type SetAllConnectionsScopeDataPayload = {
  allConnectionsScopeData: EnhancedScopeData;
  componentId: ArdoqId;
};

export const setAllConnectionsScopeData =
  actionCreator<SetAllConnectionsScopeDataPayload>(
    '[componentOverviewPage] SET_ALL_CONNECTIONS_SCOPE_DATA'
  );

export const setReferencesTabScopeData =
  actionCreator<SetComponentOverviewDataPayload>(
    '[componentOverviewPage] SET_REFERENCES_TAB_SCOPE_DATA'
  );

export const setRelevantSurveys = actionCreator<
  ComponentSurveyWithApprovalStatus[]
>('[componentOverviewPage] SET_RELEVANT_SURVEYS');

export const setComponentOverviewPageError = actionCreator(
  '[componentOverviewPage] SET_COMPONENT_OVERVIEW_PAGE_ERROR'
);

export const setComponentOverviewPageUnavailable = actionCreator(
  '[componentOverviewPage] SET_COMPONENT_OVERVIEW_PAGE_UNAVAILABLE'
);

export const setBusinessCriticalFieldIds = actionCreator<string[]>(
  '[componentOverviewPage] SET_BUSINESS_CRITICAL_FIELD_IDS'
);

export const loadComponentOverview = actionCreator<ArdoqId>(
  '[componentOverviewPage] LOAD_COMPONENT_OVERVIEW'
);
